import ErrorMessage from './Disclaimer';

export default ErrorMessage;